import React, { useState, useCallback, useEffect } from 'react';

import {
  Container,
  InputData,
  ContainerButton,
  AddPacienteButton,
  Repeticao,
  RepeticaoContainer,
  CounterContainer,
  FeitosContainer,
  CardFeitos,
  ConflitosContainer,
  CardAgenda,
  CardHorario,
  CardAgendaConteudo,
  ContainerBotao,
  Button,
  CirculoCarregandoDiv,
  CirculoCarregando,
  CardBotoes,
  ExibicaoContainer,
} from './styles';

import {
  FiAlertOctagon,
  FiCheck,
  FiPlus,
  FiTrash2,
  FiXOctagon,
} from 'react-icons/fi';

import api from '../../services/api';
import { returnAxiosError } from '../../utils/returnAxiosError';
import { useAuth } from '../../context/AuthContext';
import { useIndexedDB } from '../../context/IndexedDBContext';
import { useToast } from '../../context/ToastContext';
import { useConfigs } from '../../context/ConfigsContext';
import { adicionarMinutos } from '../../utils/adicionarMinutos';

import ComboboxComFiltro from '../../components/autocomplete';
import Paciente from '../Paciente';
import Dialog from '../../components/dialog';
import ConfirmationModal from '../../components/confirmationModal';

import { resumeNome } from '../../utils/resumeNome';

import IProfissional from '../../routes/vms/IProfissional';
import IPaciente from '../../routes/vms/IPaciente';
import ICategoria from '../../routes/vms/ICategoria';
import IListaEspera from '../../routes/vms/IListaEspera';
import ILocal from '../../routes/vms/ILocal';

interface IHorarios {
  id: string;
  nome: string;
}

interface AgendamentosFeitos {
  id: string;
  categoria: ICategoria | undefined;
  profissional: IProfissional | undefined;
  paciente: IPaciente | undefined;
  horario: string;
  recorrencia: string;
  dataPartida: string;
}

interface RetornoConflitos {
  agendamento_id?: string;
  data_criacao: Date;
  hora_ini: string;
  hora_fim: string;
  paciente?: string;
  profissional?: string;
  categoria?: string;
  descricao: string;
  inutilizado: boolean;
  tipo: string;
}

const tipoRecorrencia = [
  { id: '1', nome: 'DIARIA' },
  { id: '7', nome: 'SEMANAL' },
  { id: '14', nome: 'QUINZENAL' },
  { id: '30', nome: 'MENSAL' },
  { id: '365', nome: 'ANUAL' },
];

interface RecorrenciaProps {
  esperaSelecionada?: IListaEspera;
  onClose?(): void;
  externo: boolean;
  profissionalParametro: string;
  dataParametro?: Date;
  pacienteParametro?: IPaciente;
  horaParametro: string;
}

const Recorrencia: React.FC<RecorrenciaProps> = ({
  esperaSelecionada = undefined,
  onClose,
  externo,
  horaParametro,
  profissionalParametro,
  dataParametro,
  pacienteParametro,
}) => {
  const { user } = useAuth();
  const { addToast } = useToast();
  const { lerIndexedDB, excluirIndexedDB } = useIndexedDB();
  const { lerConfig } = useConfigs();

  const [profissional, setProfissional] = useState<string | null>(null);
  const [profissionalErro, setProfissionalErro] = useState('');
  const [local, setLocal] = useState<string | null>(null);
  const [localErro, setLocalErro] = useState<string>('');
  const [data, setData] = useState('');
  const [dataErro, setDataErro] = useState('');
  const [paciente, setPaciente] = useState<string | null>(null);
  const [pacienteErro, setPacienteErro] = useState('');
  const [horaInicio, setHoraInicio] = useState<string | null>(null);
  const [horaInicioErro, setHoraInicioErro] = useState('');
  const [horaFim, setHoraFim] = useState<string | null>(null);
  const [horaFimErro, setHoraFimErro] = useState('');
  const [tipo, setTipo] = useState<string | null>(null);
  const [tipoErro, setTipoErro] = useState('');
  const [categoria, setCategoria] = useState<string | null>(null);
  const [categoriaErro, setCategoriaErro] = useState('');

  const [isPacienteOpen, setPacienteOpen] = useState(false);

  const [espera, setEspera] = useState<IListaEspera | undefined>(undefined);

  const [termino, setTermino] = useState('Nunca');
  const [ocorrencias, setOcorrencias] = useState('1');
  const [agendamentosConflitando, setAgendamentosConflitando] = useState<
    RetornoConflitos | undefined
  >(undefined);

  const [profissionais, setProfissionais] = useState<IProfissional[]>([]);
  const [pacientes, setPacientes] = useState<IPaciente[]>([]);
  const [horarios, setHorarios] = useState<IHorarios[]>([]);
  const [categorias, setCategorias] = useState<ICategoria[]>([]);
  const [locais, setLocais] = useState<{ id: string; nome: string }[]>([]);

  const [recModalOpen, setRecModalOpen] = useState<boolean>(false);
  const [idExcluir, setIdExcluir] = useState<string>('');

  const [agendamentosFeitos, setAgendamentosFeitos] = useState<
    AgendamentosFeitos[]
  >([]);
  const [bloqueiaPaciente, setBloqueiaPaciente] = useState<boolean>(false);
  const [fazendoAgendamentos, setFazendoAgendamentos] =
    useState<boolean>(false);
  const [retornandoConflitos, setRetornandoConflitos] =
    useState<boolean>(false);
  const [carregandoDados, setCarregandoDados] = useState(false);

  const [intervalo, setIntervalo] = useState('');

  const atualizaDados = useCallback(async () => {
    try {
      setCarregandoDados(true);

      const [
        pacientesResponse,
        profissionaisResponse,
        horariosResponse,
        categoriasResponse,
        locaisResponse,
      ] = await Promise.all([
        api.get<IPaciente[]>(`/pacientes/${esperaSelecionada ? 'todos' : ''}`),
        api.get<IProfissional[]>(
          `/users/profissionais?empresa_id=${user.empresa_id}`,
        ),
        api.get<{ horarios: string[] }>('/empresas/horarios/', {
          params: {
            url_frontend: user.empresa.url_frontend,
          },
        }),
        api.get<ICategoria[]>('/categoria/lista', {
          params: { inutilizar: false },
        }),
        api.get<ILocal[]>('/local/lista'),
      ]);

      const horariosCombo: IHorarios[] = horariosResponse.data.horarios.map(
        horario => ({
          id: horario,
          nome: horario,
        }),
      );

      setPacientes(pacientesResponse.data);
      setProfissionais(profissionaisResponse.data);
      setHorarios(horariosCombo);
      setCategorias(categoriasResponse.data);
      setLocais(
        locaisResponse.data.map(local => {
          return { id: local.id, nome: local.descricao };
        }),
      );

      setCarregandoDados(false);
    } catch (error) {
      console.error('Erro ao buscar dados:', error);
    }
  }, [user, esperaSelecionada]);

  const aoAlterarProfissional = useCallback(
    (novoProfissional: string | null) => {
      setProfissional(novoProfissional);
      setProfissionalErro('');
    },
    [],
  );

  const aoAlterarLocal = useCallback(async (novoLocal: string | null) => {
    setLocal(novoLocal);
    setLocalErro('');
  }, []);

  const aoAlterarData = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setData(event.target.value);
      setDataErro('');
    },
    [],
  );

  const aoAlterarPaciente = useCallback((novoPaciente: string | null) => {
    setPaciente(novoPaciente);
    setPacienteErro('');
  }, []);

  const aoAlterarCategoria = useCallback(
    async (novaCategoria: string | null) => {
      setCategoria(novaCategoria);
      setCategoriaErro('');

      const horariosArray = await api.get<{
        horarios: string[];
        metade_intervalo: boolean;
      }>(`/empresas/horarios/`, {
        params: {
          url_frontend: user.empresa.url_frontend,
          categoria_id: novaCategoria,
        },
      });

      const horariosCombo: IHorarios[] = horariosArray.data.horarios.map(
        horario => ({
          id: horario,
          nome: horario,
        }),
      );

      setHorarios(horariosCombo);

      setHoraFim(
        adicionarMinutos(
          horaInicio,
          horariosArray.data.metade_intervalo
            ? String(Number(intervalo) / 2)
            : intervalo,
        ),
      );
    },
    [user.empresa.url_frontend, horaInicio, intervalo],
  );

  const aoAlterarHoraInicio = useCallback(
    async (novoHorario: string | null) => {
      setHoraInicio(novoHorario);

      try {
        const metade_intervalo = await api.get(
          `/categoria/${categoria ? categoria : ''}`,
        );

        setHoraFim(
          adicionarMinutos(
            novoHorario,
            metade_intervalo.data ? String(Number(intervalo) / 2) : intervalo,
          ),
        );
      } catch (error) {
        setHoraFim(adicionarMinutos(novoHorario, intervalo));
      }

      setHoraInicioErro('');
    },
    [intervalo, categoria],
  );

  const aoAlterarHoraFim = useCallback((novoHorario: string | null) => {
    setHoraFim(novoHorario);
    setHoraFimErro('');
  }, []);

  const aoAlterarTipo = useCallback((tipo: string | null) => {
    setTipo(tipo);
    setTipoErro('');
  }, []);

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setTermino(event.target.value);

      if (event.target.value === 'Nunca') {
        setOcorrencias('1');
      }
    },
    [],
  );

  const defineConflitos = useCallback(async requestData => {
    setRetornandoConflitos(true);

    const conflitos = await api.get<RetornoConflitos>(
      '/agendamentos/conflitos',
      { params: requestData },
    );

    if (conflitos.data) {
      setAgendamentosConflitando(conflitos.data);
    }

    setRetornandoConflitos(false);
  }, []);

  const handleExcluirRecorrencia = useCallback(
    async (motivo: string) => {
      try {
        setFazendoAgendamentos(true);

        await api.post(`/agendamentos/excluir/${idExcluir}/${true}`, {
          motivo,
          data,
        });

        setFazendoAgendamentos(false);

        setAgendamentosFeitos(prevItems =>
          prevItems.filter(item => item.id !== idExcluir),
        );

        setIdExcluir('');
        setRecModalOpen(false);
      } catch (error) {
        addToast(returnAxiosError(error));

        return;
      }
    },
    [addToast, idExcluir, data],
  );

  const validacoes = useCallback(() => {
    setDataErro('');
    setPacienteErro('');
    setTipoErro('');
    setProfissionalErro('');
    setCategoriaErro('');
    setHoraInicioErro('');
    setHoraFimErro('');
    setLocalErro('');

    let erroValidacao = false;
    if (data === '') {
      setDataErro('Informação obrigatória!');
      erroValidacao = true;
    }
    if (!paciente) {
      setPacienteErro('Informação obrigatória!');
      erroValidacao = true;
    }
    if (!tipo) {
      setTipoErro('Informação obrigatória!');
      erroValidacao = true;
    }

    if (!profissional) {
      setProfissionalErro('Informação obrigatória!');
      erroValidacao = true;
    }
    if (!categoria) {
      setCategoriaErro('Informação obrigatória!');
      erroValidacao = true;
    }
    if (!horaInicio) {
      setHoraInicioErro('Informação obrigatória!');
      erroValidacao = true;
    }
    if (!horaFim) {
      setHoraFimErro('Informação obrigatória!');
      erroValidacao = true;
    }
    if (lerConfig('LOCAL OBRIGATÓRIO PARA AGENDAMENTOS') === 'SIM') {
      if (!local) {
        setLocalErro('Informação obrigatória!');
        erroValidacao = true;
      }
    }

    if (erroValidacao) {
      addToast({
        type: 'info',
        title: 'Pendências na validação',
        description:
          'Efetue as correções indicadas em cada campo e tente novamente.',
      });
      return false;
    }
  }, [
    addToast,
    categoria,
    data,
    horaFim,
    horaInicio,
    paciente,
    profissional,
    tipo,
    local,
    lerConfig,
  ]);

  const finalizar = useCallback(() => {
    setData('');
    setPaciente(null);
    setTipo(null);
    setTermino('Nunca');
    setProfissional(null);
    setCategoria(null);
    setHoraInicio(null);
    setHoraFim(null);
    setBloqueiaPaciente(false);
    setOcorrencias('');
    setAgendamentosFeitos([]);
    setAgendamentosConflitando(undefined);

    if (externo) {
      if (onClose) {
        onClose();
      }
    }
  }, [externo, onClose]);

  const limpaCampos = useCallback(() => {
    setProfissional(null);
    setCategoria(null);
    setHoraInicio(null);
    setHoraFim(null);
  }, []);

  const handleOpenPaciente = () => setPacienteOpen(true);

  // function getRandomInt(min: number, max: number) {
  //   return Math.floor(Math.random() * (max - min + 1)) + min;
  // }

  const handleClosePaciente = useCallback(async () => {
    setPacienteOpen(false);

    lerIndexedDB<string>(
      `${user.empresa.url_frontend}:id-paciente-gravado`,
    ).then(idIndexedDB => {
      if (idIndexedDB !== null) {
        setPaciente(String(idIndexedDB));
        atualizaDados();

        excluirIndexedDB(`${user.empresa.url_frontend}:id-paciente-gravado`);
      }
    });
  }, [atualizaDados, excluirIndexedDB, lerIndexedDB, user]);

  const aoAlterarOcorrencia = (e: React.ChangeEvent<HTMLInputElement>) => {
    const valor = e.target.value;

    if (valor === '' || (!isNaN(Number(valor)) && Number(valor) >= 1)) {
      setOcorrencias(valor);
    }
  };

  const fazAgendamentoHorario = useCallback(
    async (
      hora_ini: string,
      hora_fim: string,
      idAgendamento: string | undefined,
    ) => {
      const requestData = {
        categoria_id: categoria,
        data_ini: data,
        hora_ini,
        hora_fim,
        infinita: termino === 'Nunca' ? 'true' : 'false',
        numero_ocorrencias: ocorrencias,
        paciente_id: paciente,
        profissional_id: profissional,
        recorrencia: tipo,
      };

      setFazendoAgendamentos(true);

      const response = await api.post<string>(
        `/agendamentos/recorrencia/${false}`,
        requestData,
      );

      let tipoRecorrencia = '';
      switch (tipo) {
        case '1':
          tipoRecorrencia = 'DIÁRIA';
          break;
        case '7':
          tipoRecorrencia = 'SEMANAL';
          break;
        case '30':
          tipoRecorrencia = 'MENSAL';
          break;
        case '365':
          tipoRecorrencia = 'ANUAL';
          break;
        default:
          break;
      }

      const dataFormatada = new Date(data);
      dataFormatada.setHours(dataFormatada.getHours() + 3);

      const agendamentoFeito: AgendamentosFeitos = {
        id: response.data,
        categoria: categorias.find(c => {
          if (c.id === categoria) {
            return c.nome;
          }

          return '';
        }),
        dataPartida: Intl.DateTimeFormat('pt-BR').format(dataFormatada),
        horario: `${hora_ini}h até ${hora_fim}h`,
        profissional: profissionais.find(p => {
          if (p.id === profissional) {
            return p.name;
          }

          return '';
        }),
        paciente: pacientes.find(p => {
          if (p.id === paciente) {
            return p.nome;
          }

          return '';
        }),
        recorrencia: tipoRecorrencia,
      };

      setAgendamentosFeitos([...agendamentosFeitos, agendamentoFeito]);

      setFazendoAgendamentos(false);
      setBloqueiaPaciente(true);

      addToast({
        type: 'success',
        title: 'Agendamentos Cadastrados',
        description: 'Agendamentos recorrentes cadastrados com sucesso',
      });

      if (espera) {
        await api.post(`/espera/excluir/${espera.id}`, {
          motivo: `PACIENTE AGENDADO EM RECORRÊNCIA`,
        });

        setEspera(undefined);
      }

      setAgendamentosConflitando(undefined);
    },
    [
      addToast,
      agendamentosFeitos,
      categoria,
      categorias,
      data,
      espera,
      ocorrencias,
      paciente,
      pacientes,
      profissionais,
      profissional,
      termino,
      tipo,
    ],
  );

  const prosseguir = useCallback(async () => {
    if (esperaSelecionada) {
      try {
        await api.get(
          `/pacientes/valida-espera/${esperaSelecionada.paciente.id}`,
        );
      } catch (error) {
        addToast({
          title: 'Validação',
          description: 'Erro de validação. Corrija no cadastro para prosseguir',
          type: 'error',
        });

        setPacienteOpen(true);

        return;
      }

      if (esperaSelecionada.paciente.tipo === 'ESPERA') {
        await api.patch(`/pacientes/define/${esperaSelecionada.paciente.id}`);
      }
    }

    if (validacoes() === false) {
      return;
    }

    const requestData = {
      categoria_id: categoria,
      data_ini: data,
      hora_ini: horaInicio,
      hora_fim: horaFim,
      infinita: termino === 'Nunca' ? 'true' : 'false',
      numero_ocorrencias: ocorrencias,
      paciente_id: paciente,
      profissional_id: profissional,
      recorrencia: tipo,
      local_id: local,
    };

    try {
      setAgendamentosConflitando(undefined);

      setFazendoAgendamentos(true);

      const response = await api.post<string>(
        `/agendamentos/recorrencia/${true}`,
        requestData,
      );

      let tipoRecorrencia = '';
      switch (tipo) {
        case '1':
          tipoRecorrencia = 'DIÁRIA';
          break;
        case '7':
          tipoRecorrencia = 'SEMANAL';
          break;
        case '30':
          tipoRecorrencia = 'MENSAL';
          break;
        case '365':
          tipoRecorrencia = 'ANUAL';
          break;
        default:
          break;
      }

      const dataFormatada = new Date(data);
      dataFormatada.setHours(dataFormatada.getHours() + 3);

      const agendamentoFeito: AgendamentosFeitos = {
        id: response.data,
        categoria: categorias.find(c => {
          if (c.id === categoria) {
            return c.nome;
          }

          return '';
        }),
        dataPartida: Intl.DateTimeFormat('pt-BR').format(dataFormatada),
        horario: `${horaInicio}h até ${horaFim}h`,
        profissional: profissionais.find(p => {
          if (p.id === profissional) {
            return p.name;
          }

          return '';
        }),
        paciente: pacientes.find(p => {
          if (p.id === paciente) {
            return p.nome;
          }

          return '';
        }),
        recorrencia: tipoRecorrencia,
      };

      setAgendamentosFeitos([...agendamentosFeitos, agendamentoFeito]);

      setFazendoAgendamentos(false);
      setBloqueiaPaciente(true);

      addToast({
        type: 'success',
        title: 'Agendamentos Cadastrados',
        description: 'Agendamentos recorrentes cadastrados com sucesso',
      });

      if (espera) {
        await api.post(`/espera/excluir/${espera.id}`, {
          motivo: `PACIENTE AGENDADO EM RECORRÊNCIA`,
        });

        setEspera(undefined);
      }
      limpaCampos();
    } catch (error) {
      setFazendoAgendamentos(false);

      const axiosError = returnAxiosError(error);
      if (
        axiosError.title ===
        'Resolva os conflitos de horários para prosseguir com o agendamento'
      ) {
        defineConflitos(requestData);
      }
      addToast(axiosError);
    }
  }, [
    validacoes,
    esperaSelecionada,
    espera,
    categorias,
    profissionais,
    pacientes,
    local,
    categoria,
    data,
    horaFim,
    horaInicio,
    ocorrencias,
    paciente,
    profissional,
    termino,
    tipo,
    agendamentosFeitos,
    addToast,
    limpaCampos,
    defineConflitos,
  ]);

  useEffect(() => {
    atualizaDados();
    setIntervalo(lerConfig('INTERVALO'));
  }, [atualizaDados, lerConfig]);

  useEffect(() => {
    if (esperaSelecionada) {
      setEspera(esperaSelecionada);
      setPaciente(esperaSelecionada.paciente.id);
      setCategoria(esperaSelecionada.categoria.id);
    }
  }, [esperaSelecionada]);

  useEffect(() => {
    if (profissionalParametro !== '') {
      setProfissional(profissionalParametro);
    }

    if (pacienteParametro) {
      setPaciente(pacienteParametro.id);
    }

    if (horaParametro !== '') {
      setHoraInicio(horaParametro);
      setHoraFim(adicionarMinutos(horaParametro, intervalo));
    }

    if (dataParametro) {
      setData(dataParametro.toISOString().slice(0, 10));
    }
  }, [
    dataParametro,
    horaParametro,
    profissionalParametro,
    pacienteParametro,
    intervalo,
  ]);

  return fazendoAgendamentos || carregandoDados ? (
    <CirculoCarregandoDiv>
      <CirculoCarregando />
    </CirculoCarregandoDiv>
  ) : (
    <Container>
      <ContainerBotao>
        <h1>Recorrência de Agendamentos</h1>
        <div>
          <Button onClick={prosseguir}>Prosseguir</Button>
          <Button onClick={finalizar}>Finalizar</Button>
        </div>
      </ContainerBotao>

      <span
        style={{
          background: '#F5F5F5',
          padding: '1px 10px',
          borderRadius: '8px',
        }}
      >
        <InputData
          variant="outlined"
          margin="normal"
          id="data"
          label="A partir de"
          name="data"
          type="date"
          InputLabelProps={{
            shrink: true,
          }}
          value={data}
          onChange={aoAlterarData}
          error={dataErro !== ''}
          helperText={dataErro}
          style={{ marginRight: '8px', flex: 2 }}
        />

        <ContainerButton>
          <ComboboxComFiltro
            opcoes={pacientes}
            value={paciente}
            label="Paciente"
            onChange={aoAlterarPaciente}
            error={pacienteErro !== ''}
            helperText={pacienteErro}
            disabled={bloqueiaPaciente || !!espera || !!pacienteParametro}
          />

          <AddPacienteButton
            title="Cadastrar Paciente"
            onClick={handleOpenPaciente}
            disabled={bloqueiaPaciente || !!espera}
          >
            <FiPlus />
          </AddPacienteButton>

          <Dialog isOpen={isPacienteOpen} onClose={handleClosePaciente}>
            <Paciente
              externa={true}
              pacienteParametro={esperaSelecionada?.paciente}
              onClose={handleClosePaciente}
            />
          </Dialog>
        </ContainerButton>

        <ComboboxComFiltro
          opcoes={tipoRecorrencia}
          value={tipo}
          label="Tipo"
          onChange={aoAlterarTipo}
          error={tipoErro !== ''}
          helperText={tipoErro}
          size={2}
          temMargin={true}
        />

        <Repeticao>
          <p>Término: </p>
          <RepeticaoContainer>
            <label>
              <input
                type="radio"
                value="Nunca"
                checked={termino === 'Nunca'}
                onChange={handleChange}
              />
              Nunca
            </label>
            <label>
              <input
                type="radio"
                value="Após"
                checked={termino === 'Após'}
                onChange={handleChange}
              />
              Após
            </label>
          </RepeticaoContainer>
        </Repeticao>

        <CounterContainer oculto={termino !== 'Após'}>
          <input
            type="number"
            value={ocorrencias}
            onChange={aoAlterarOcorrencia}
          />
        </CounterContainer>
      </span>

      <span style={{ padding: '1px 10px' }}>
        <ComboboxComFiltro
          opcoes={profissionais}
          value={profissional}
          label="Profissional"
          onChange={aoAlterarProfissional}
          error={profissionalErro !== ''}
          helperText={profissionalErro}
          size={3}
          temMargin={true}
        />

        <ComboboxComFiltro
          opcoes={locais}
          value={local}
          label="Local Atendimento"
          onChange={aoAlterarLocal}
          error={localErro !== ''}
          helperText={localErro}
          size={2}
          temMargin={true}
        />

        <ComboboxComFiltro
          opcoes={categorias}
          value={categoria}
          label="Categoria"
          onChange={aoAlterarCategoria}
          error={categoriaErro !== ''}
          helperText={categoriaErro}
          size={2}
          temMargin={true}
        />

        <ComboboxComFiltro
          opcoes={horarios}
          value={horaInicio}
          label="Hora Início"
          onChange={aoAlterarHoraInicio}
          error={horaInicioErro !== ''}
          helperText={horaInicioErro}
          size={1}
          temMargin={true}
        />

        <ComboboxComFiltro
          opcoes={horarios}
          value={horaFim}
          label="Hora Fim"
          onChange={aoAlterarHoraFim}
          error={horaFimErro !== ''}
          helperText={horaFimErro}
          size={1}
        />
      </span>

      <ExibicaoContainer>
        {agendamentosFeitos.length > 0 && (
          <FeitosContainer>
            {agendamentosFeitos.map(feitos => (
              <CardFeitos
                key={feitos.id}
                title={`${feitos.paciente?.nome} - ${feitos.categoria?.nome}`}
                cor={feitos.categoria?.cor}
              >
                <span>
                  <p>{resumeNome(feitos.profissional?.name)}</p>
                  <FiTrash2
                    onClick={() => {
                      setIdExcluir(feitos.id);
                      setRecModalOpen(true);
                    }}
                  />
                </span>
                <div>
                  <h3>{feitos.recorrencia}</h3>
                  <div>{feitos.dataPartida}</div>
                  <div>{feitos.horario}</div>
                </div>
              </CardFeitos>
            ))}
          </FeitosContainer>
        )}

        <ConflitosContainer>
          {retornandoConflitos ? (
            <CirculoCarregandoDiv>
              <CirculoCarregando />
            </CirculoCarregandoDiv>
          ) : (
            agendamentosConflitando && (
              <CardAgenda key={agendamentosConflitando.agendamento_id}>
                <CardHorario
                  profissional={agendamentosConflitando.tipo === 'amarelo'}
                >
                  <h3>{`${agendamentosConflitando.data_criacao
                    .toString()
                    .split('T')[0]
                    .split('-')
                    .reverse()
                    .join('/')}
                  `}</h3>
                  <h3>{`${agendamentosConflitando.hora_ini}h até ${agendamentosConflitando.hora_fim}h`}</h3>
                </CardHorario>

                <CardAgendaConteudo
                  profissional={agendamentosConflitando.tipo === 'amarelo'}
                >
                  <div>
                    {agendamentosConflitando.tipo === 'amarelo' ? (
                      <FiAlertOctagon />
                    ) : (
                      <FiXOctagon />
                    )}
                  </div>

                  <div>
                    <p style={{ marginRight: '35px' }}>CONFLITO</p>
                    <p
                      style={{
                        marginRight: '35px',
                        whiteSpace: 'pre-line',
                        lineHeight: '1.5',
                      }}
                    >
                      {agendamentosConflitando.descricao}
                    </p>
                  </div>
                </CardAgendaConteudo>

                <CardBotoes
                  profissional={agendamentosConflitando.tipo === 'amarelo'}
                  visivel={agendamentosConflitando.tipo === 'amarelo'}
                >
                  {agendamentosConflitando.profissional && (
                    <div
                      onClick={() => {
                        fazAgendamentoHorario(
                          agendamentosConflitando.hora_ini,
                          agendamentosConflitando.hora_fim,
                          agendamentosConflitando.agendamento_id,
                        );
                      }}
                    >
                      <FiCheck />
                    </div>
                  )}

                  {/* <div
                onClick={() => {
                  setAgendamentoSelecionado(conflito.agendamento);
                  setModalOpen(true);
                }}
              >
                <FiTrash2 />
              </div> */}
                </CardBotoes>
              </CardAgenda>
            )
          )}
        </ConflitosContainer>
      </ExibicaoContainer>

      <ConfirmationModal
        open={recModalOpen}
        title="Confirmar Exclusão"
        message="Informe o motivo para excluir TODOS os horários dessa recorrência"
        exigeMotivo={true}
        onConfirm={motivo => {
          handleExcluirRecorrencia(motivo);
        }}
        onCancel={() => setRecModalOpen(false)}
      />
    </Container>
  );
};

export default Recorrencia;
